import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { httpRequest } from '@calendly/http-tools'

import { useGetEventTypeQuery, useGetProfileQuery, useGetFeaturesQuery } from 'root-api'

export const usePackageForLocale = () => {
  const { profileSlug, packageUuid } = useParams()
  const [pkg, setPkg] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchPackage = async () => {
      if (!packageUuid) {
        setLoading(false)
        return
      }

      try {
        const [ok, response] = await httpRequest({
          url: `/api/booking/packages/${packageUuid}`,
          method: 'GET',
        })

        if (ok && response?.resource) {
          setPkg(response.resource)
        } else if (!ok) {
          const statusCode = response?.status || response?.statusCode
          const isNotFound = statusCode === 404
            || (!statusCode && response?.message
              && response.message.toLowerCase().includes('not found'))

          if (isNotFound) {
            window.location.href = '/404/index.html'
          }
        }
      } finally {
        setLoading(false)
      }
    }

    fetchPackage()
  }, [packageUuid])

  const items = pkg?.variants?.[0]?.items
  const eventTypeItem = items?.find((item) => item.item_type === 'event_types')
  const eventTypeUuid = eventTypeItem?.item_uuid ?? items?.[0]?.item_uuid

  const { data: eventType, isLoading: isEventTypeLoading } = useGetEventTypeQuery(
    { eventTypeUuid },
    { skip: !eventTypeUuid },
  )

  const { data: profile, isLoading: profileLoading } = useGetProfileQuery(
    { slug: profileSlug },
    { skip: !profileSlug },
  )

  const { data: features } = useGetFeaturesQuery(
    { uuid: profile?.organization_uuid },
    { skip: !profile?.organization_uuid },
  )

  const isWaitingForEventType = eventTypeUuid && isEventTypeLoading

  return {
    loading: loading || isWaitingForEventType || profileLoading || !profile,
    eventType,
    packageData: pkg,
    profile,
    features,
  }
}
